var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/* No販売店情報（一覧） */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { render } from 'react-dom';
import axios from '../../axios';
import { handleBrowzerBack } from '../../BrowzerBack';
import NoStoreSearchForm from '../../organisms/NoStoreSearchForm';
import NoStoreList from '../../organisms/NoStoreList';
import LoadingModal from '../../organisms/LoadingModal';
import { useToggle } from '../../hooks/ToggleHooks';
import { no_store_search_params_init, api_response_type, content_type } from '../../Const';
import { Modal, Button } from 'react-bootstrap';
import { fileDownload } from '../../FileDownload';
var NoStore = function () {
    // 検索パラメータ、セッションストレージに値がある場合そこから復元する
    var _a = useState(function () {
        var saved_data = sessionStorage.getItem('search_conditions');
        if (saved_data) {
            try {
                return JSON.parse(saved_data);
            }
            catch (error) {
                return no_store_search_params_init;
            }
        }
        return no_store_search_params_init;
    }), search_params = _a[0], setSearchParams = _a[1];
    var _b = useState(false), is_loading = _b[0], setIsLoading = _b[1];
    var _c = useState([]), stores = _c[0], setStores = _c[1];
    // D-Codeリスト
    var _d = useState([]), d_code_list = _d[0], setDCodeList = _d[1];
    // NO統括権限リスト
    var _e = useState([]), no_supervision_list = _e[0], setNoSupervisionList = _e[1];
    // エラー用モーダル
    var _f = useToggle(false), modal_output_exception = _f[0], toggleModalOutputException = _f[1];
    var _g = useState(''), modal_output_exception_body = _g[0], setModalOutputExceptionBody = _g[1];
    // CSV一括登録動作中フラグ
    var isBulkRegistering = useRef(false);
    // 検索ボタン押下フラグ
    // セッションストレージに値がない場合falseが入り、検索ボタン押下でtrueとなります
    var isSearchPressed = useRef(sessionStorage.getItem('is_search_pressed') !== null);
    useEffect(function () {
        // ブラウザの戻る・進む禁止
        handleBrowzerBack();
        search();
        loadDCodeListAndNoSupervision();
    }, []);
    /**
     * D-CODE(旧NOコード)とNO統括権限のリストを取得
     * @returns void
     */
    var loadDCodeListAndNoSupervision = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, axios.get('staff/no_store/list/search/option')];
                case 1:
                    response = _a.sent();
                    setDCodeList(response.data.option_d_code);
                    setNoSupervisionList(response.data.option_no_supervision);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 検索処理
     * @returns void
     */
    var search = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 検索ボタンを押下するまで検索を行わない
                    if (!isSearchPressed.current) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsLoading(true);
                    return [4 /*yield*/, axios.get('staff/no_store/list/search', {
                            params: search_params,
                        })];
                case 2:
                    response = _a.sent();
                    setStores(response.data.no_store_list);
                    setDCodeList(response.data.option_d_code);
                    setNoSupervisionList(response.data.option_no_supervision);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    // 検索パラメータをセッションストレージに保存
                    sessionStorage.setItem('search_conditions', JSON.stringify(search_params));
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [search_params]);
    /**
     * 検索ボタン押下時に、検索フラグを立てて検索を行う
     * @returns void
     */
    var handleClickSearch = function () {
        // 検索ボタン押下済みフラグを立てる
        if (!isSearchPressed.current) {
            sessionStorage.setItem('is_search_pressed', 'true');
            isSearchPressed.current = true;
        }
        search();
    };
    /**
     * 検索パラメータ変更
     * @param event React.ChangeEvent<HTMLInputElement | HTMLSelectElement> イベントオブジェクト
     * @returns void
     */
    var handleChangeSearchParams = useCallback(function (event) {
        var _a = event.currentTarget, name = _a.name, value = _a.value;
        setSearchParams(function (prev) {
            var _a, _b;
            var currentData = prev[name];
            if (Array.isArray(currentData)) {
                // 配列の中身がstringであるとアサーション
                var currentArray = currentData;
                // 変更する値と現在の値を比較し、現在の値に存在する場合削除、存在しない場合追加
                var newArray = currentArray.includes(value)
                    ? currentData.filter(function (v) { return v !== value; })
                    : __spreadArray(__spreadArray([], currentData), [value]);
                return __assign(__assign({}, prev), (_a = {}, _a[name] = newArray, _a));
            }
            return __assign(__assign({}, prev), (_b = {}, _b[name] = value, _b));
        });
    }, [search_params]);
    /**
     * 登録ボタンのイベント
     * @returns void
     */
    var handleClickCreateButton = function () {
        location.href = "" + location.origin + process.env.MIX_MOCK_URL + "/staff/no_store/create";
    };
    /**
     *　EXPORTボタン押下時の処理
     * @return void
     */
    var handleClickCSVExport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var stores_detail, request_param, errorMessage;
        return __generator(this, function (_a) {
            try {
                setIsLoading(true);
                stores_detail = stores.flat().map(function (item) { return ({
                    id: item.id,
                    reception_id: '',
                    reception_cd: '',
                }); });
                request_param = editRequestParam('OutputCsvNoStoreMaster', stores_detail);
                postData(request_param);
            }
            catch (error) {
                errorMessage = error instanceof Error ? error.message : String(error);
                toggleModalOutputException();
                setModalOutputExceptionBody(errorMessage);
                setIsLoading(false);
            }
            return [2 /*return*/];
        });
    }); };
    /**
     * API呼び出し時のリクエストパラメータ編集
     * @param function_name 呼び出しモジュール名
     * @param detail 詳細情報
     * @return PostData
     */
    var editRequestParam = function (function_name, detail) {
        var post_data = {
            reception_id: null,
            reception_cd: null,
            module_name: function_name,
            detail: detail,
            is_json: true,
        };
        return post_data;
    };
    /**
     * APIに値をPOSTする
     *
     * @param post_data postするデータ
     * @return void
     */
    var postData = function (post_data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_3, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    setIsLoading(true);
                    return [4 /*yield*/, axios.post('/api/common', post_data)];
                case 1:
                    response = _a.sent();
                    // レスポンス事に、処理を分岐
                    allocationResponseData(response.data, post_data);
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _a.sent();
                    errorMessage = error_3 instanceof Error ? error_3.message : String(error_3);
                    toggleModalOutputException();
                    setModalOutputExceptionBody(errorMessage);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    clearProcessingFlags();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * ファイルを選択した後の処理
     * @param event イベント
     * @returns void
     */
    var handleFileSelect = useCallback(function (event) {
        if (event === null || event.target === null || event.target.files === null) {
            return;
        }
        var file = event.target.files[0];
        event.target.value = '';
        var module_name = 'CsvNoStoreMaster';
        // CSV以外を選択した場合、エラーダイアログを表示する
        if (!file.name.match(/[.]csv$/)) {
            toggleModalOutputException();
            setModalOutputExceptionBody('CSVファイルを選択してください。');
            return;
        }
        // postデータを生成する;
        var post_data = new FormData();
        post_data.append('module_name', module_name);
        post_data.append('is_json', 'false');
        post_data.append('file', file);
        isBulkRegistering.current = true;
        postData(post_data);
    }, []);
    /**
     * レスポンス値を元に処理を振り分ける
     * @param {ResponseData} response_data レスポンスデータ
     * @param {PostData} post_data postしたデータ
     */
    var allocationResponseData = function (response_data, post_data) { return __awaiter(void 0, void 0, void 0, function () {
        var displayMessage;
        return __generator(this, function (_a) {
            setIsLoading(false);
            displayMessage = response_data.message;
            if (response_data.result) {
                switch (response_data.response_type) {
                    case api_response_type.download:
                        downloadCsv(post_data);
                        break;
                    case api_response_type.err_msg:
                        setModalOutputExceptionBody(displayMessage);
                        toggleModalOutputException();
                        break;
                    case api_response_type.validation:
                        setValidMessage(response_data);
                        break;
                    case api_response_type.dialog:
                        if (isBulkRegistering.current) {
                            displayMessage = 'CSV一括登録が正常に完了しました';
                        }
                        setModalOutputExceptionBody(displayMessage);
                        toggleModalOutputException();
                        break;
                }
            }
            else {
                // 例外発生
                if (isBulkRegistering.current) {
                    displayMessage = 'CSV一括登録に失敗しました。CSVデータをご確認ください';
                }
                setModalOutputExceptionBody(displayMessage);
                toggleModalOutputException();
            }
            return [2 /*return*/];
        });
    }); };
    /**
     * バリデーションエラーメッセージを整形して表示
     *
     * @param response_data
     */
    var setValidMessage = function (response_data) {
        try {
            var error_message = function (response_data) {
                // detailが存在しない場合は、バリデーションエラーがあった旨のみを表示
                if (!response_data ||
                    !Array.isArray(response_data.detail) ||
                    response_data.detail.length === 0) {
                    return 'アップロードされたCSVファイルに無効なデータが見つかりました。ファイルの内容を確認して再度お試しください。';
                }
                return [
                    React.createElement("div", { key: "error-container", className: "validation-error-container" }, response_data.detail.map(function (text, index) {
                        var _a = text.split(' : '), lineNumber = _a[0], messageParts = _a.slice(1);
                        var message = messageParts.length > 0 ? messageParts.join(' : ') : '';
                        return (React.createElement(React.Fragment, { key: index },
                            React.createElement("div", { className: "validation-error-index" },
                                lineNumber,
                                " \uFF1A"),
                            React.createElement("div", { className: "validation-error-message" }, message)));
                    })),
                ];
            };
            toggleModalOutputException();
            setModalOutputExceptionBody(error_message(response_data));
        }
        catch (exception) {
            console.error(exception);
        }
    };
    /**
     * CSVをダウンロード
     *
     * @param {PostData} post_data postしたデータ
     */
    var downloadCsv = function (post_data) { return __awaiter(void 0, void 0, void 0, function () {
        var download_response, error_4, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, axios.post('/api/common', __assign(__assign({}, post_data), { is_json: false }), {
                            responseType: 'blob',
                        })];
                case 1:
                    download_response = _a.sent();
                    fileDownload(download_response.data, download_response.headers['content-disposition'], content_type.csv);
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    errorMessage = error_4 instanceof Error ? error_4.message : String(error_4);
                    toggleModalOutputException();
                    setModalOutputExceptionBody(errorMessage);
                    return [3 /*break*/, 4];
                case 3:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /**
     * 各種処理状態をfalseに変更
     *
     * @param void
     * @returns void
     */
    var clearProcessingFlags = function () {
        isBulkRegistering.current = false;
    };
    return (React.createElement("div", null,
        React.createElement(Modal, { show: modal_output_exception, onHide: function () { } },
            React.createElement(Modal.Body, { className: "dialog-body" }, modal_output_exception_body),
            React.createElement(Modal.Footer, null,
                React.createElement(Button, { variant: "main-color", onClick: toggleModalOutputException }, "OK"))),
        React.createElement("div", { className: "container" },
            React.createElement(NoStoreSearchForm, { search_params: search_params, search_option: d_code_list, search_option_no_supervision: no_supervision_list, handleClickSearch: handleClickSearch, handleChangeSearchParams: handleChangeSearchParams, handleClickCreateButton: handleClickCreateButton, handleClickExportButton: handleClickCSVExport, handleFileSelect: handleFileSelect, is_loading: is_loading }),
            React.createElement(NoStoreList, { no_stores: stores })),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('no-store-list')) {
    render(React.createElement(NoStore, null), document.getElementById('no-store-list'));
}
